/*
Copyright (c) 2019 [these people](https://github.com/berezh/react-string-format/graphs/contributors)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

/*
Modified a few lines of the source code to work with variables, instead of numbers

Original Example:
format('firstName: {0}; lastName: {1}', 'tom', 'hanks');
// result:
'firstName: tom; lastName: hanks'


Swoop's Modified Version:
format('firstName: {first}; lastName: {last}', {first: "tom", last: "hanks"});
// result:
'firstName: tom; lastName: hanks'
*/

import React from "react";

export function format(
  text: string,
  search: { [key: string]: React.ReactElement | string }
): string | React.ReactElement {
  let result = [text];

  Object.keys(search).forEach((key) => {
    result = parseAndReplace(result, key, search[key]);
  });

  if (result.length === 0) {
    return "";
  } else if (result.length === 1 && typeof result[0] === "string") {
    return result[0];
  } else {
    return React.createElement(
      React.Fragment,
      null,
      result.map((x, i) => {
        return React.createElement(React.Fragment, { key: i }, x);
      })
    );
  }
}

function parseAndReplace(source, key, replaceWith) {
  const result = [];
  source.forEach((possibleText) => {
    if (typeof possibleText === "string") {
      const pattern = new RegExp("\\{" + key + "\\}", "gi");
      if (typeof replaceWith === "string" || typeof replaceWith === "number") {
        result.push(possibleText.replace(pattern, "" + replaceWith));
      } else {
        const splits_1 = possibleText.split(pattern);
        splits_1.forEach((splitText, i) => {
          if (splitText) {
            result.push(splitText);
          }
          // if NOT last
          if (i + 1 < splits_1.length) {
            result.push(replaceWith);
          }
        });
      }
    } else {
      result.push(possibleText);
    }
  });
  return result;
}
